<script setup>
import { computed, onMounted, watch } from 'vue';
import { useSharedPopup } from '@vuejs/composables/useSharedPopup';
import Loader from '@vuejs/components/Loader.vue';

const sharedPopup = useSharedPopup();

onMounted(() => {
    window.addEventListener('DOMContentLoaded', () => {
        let eventAttached = false;

        const modalElement = document.querySelector('#shared-popup-app');

        // if (window.IS_MOBILE) {
        //     modalElement.classList.add('modal-bottom')
        // } else {
        //     modalElement.classList.add('modal-end')
        // }

        const modalInstance = new window.bootstrap.Modal(modalElement, {
            keyboard: false,
        });

        window.bootstrap.popup = modalInstance;

        window.bootstrap.modal._element.addEventListener('shown.bs.modal', () => {
            if (!eventAttached) {
                console.log(window.bootstrap.modal._backdrop._element);

                window.bootstrap.modal._backdrop._element.addEventListener('click', () => {
                    console.log('click');

                    sharedPopup.hide();
                });
            }

            eventAttached = true;
        });

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && sharedPopup.getCurrent) {
                sharedPopup.hide();
            }
        });
    });

    window.addEventListener('vue.popup.show', ({ detail: { componentName, payload } }) => {
        console.log({ componentName, payload });
        sharedPopup.show(componentName, payload);
    });

    window.addEventListener('vue.popup.replace', ({ detail: { componentName, payload } }) => {
        sharedPopup.replace(componentName, payload);
    });

    window.addEventListener('vue.popup.hide', (e) => {
        sharedPopup.hide();
    });

    window.addEventListener('vue.popup.hide-all', (e) => {
        sharedPopup.hideAll();
    });
});
</script>

<template>
    <div class="modal-dialog rounded-3 overflow-hidden modal-dialog-bottom-left">
        <div class="modal-content">
            <span
                class="p-5 px-lg-6 py-lg-5 position-absolute top-0 end-0 cursor-pointer z-1 x-mark"
            >
                <template v-if="sharedPopup.getAmount.value > 1">
                    <span @click="sharedPopup.hide" class="fs-6 text-capitalize text-custom-5">
                        <font-awesome-icon :icon="['fal', 'angle-left']" class="me-2" />
                        {{ $t('global.go-back') }}</span
                    >
                </template>
                <template v-else>
                    <div
                        class="bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                        style="width: 28px; height: 28px; cursor: pointer"
                        @click="sharedPopup.hide"
                    >
                        <font-awesome-icon :icon="['fal', 'xmark']" class="fs-5" />
                    </div>
                </template>
            </span>

            <template v-if="sharedPopup.getCurrent.value">
                <KeepAlive>
                    <Suspense timeout="0">
                        <component
                            :is="sharedPopup.getCurrent.value.component"
                            v-bind="sharedPopup.getCurrent.value.payload"
                        >
                        </component>

                        <template #fallback>
                            <Loader />
                        </template>
                    </Suspense>
                </KeepAlive>
            </template>
        </div>
    </div>
</template>
<style scoped>
.modal-dialog-bottom-left {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    margin: 0;
    width: 400px;
    max-width: 100%;
    transform: none;
}

.modal-dialog-bottom-right .modal-content {
    border-radius: 8px;
}
</style>
